import { render } from "./template.vue?vue&type=template&id=c600b880&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=c600b880&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c600b880"]])

export default __exports__